import { NgClass, NgIf } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { SavedSearchModel } from "../../saved-search.model";
import { SavedSearchesService } from "../../saved-searches.service";

@Component({
    selector: "pcg-ng-saved-search-card",
    templateUrl: "saved-search-card.component.html",
    imports: [
        NgClass,
        FormsModule,
        NgIf
    ],
    standalone: true
})
export class SavedSearchCardComponent implements OnInit {
    public editing = false;
    @Input() public savedSearch: SavedSearchModel;
    public formModel: SavedSearchModel;

    public constructor(
        private savedSearchesService: SavedSearchesService
    ) {
    }

    public ngOnInit(): void {
        this.formModel = { ...this.savedSearch };
    }

    public onStartEditing(): void {
        this.formModel = { ...this.savedSearch };
        this.editing = true;
    }

    public onEndEditing(): void {
        this.editing = false;
    }

    public onSave(): void {
        this.savedSearchesService.update(this.formModel);
        this.editing = false;
    }

    public onDelete(): void {
        this.savedSearchesService.delete(this.savedSearch);
    }

    public onCancel(): void {
        this.editing = false;
    }
}
